import styled from '@emotion/styled';
import { Divider } from 'antd';
import { useEffect } from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import { ORANGE, PRIMARY, YELLOW } from '../../../../shared/colors';
import { Layout } from '../../../shared/Layout';
import { BondForm } from '../components/BondForm';

const Container = styled.div`
  height: calc(100vh - 30px);
  display: flex;
  background-color: #1c2025;
  color: white;

  .bread-crum span {
    color: white;
  }

  td.ant-table-column-sort {
    background-color: transparent !important;
  }

  th {
    background-color: ${PRIMARY} !important;
    color: white !important;
    font-weight: bold;
  }

  .odd-row {
    background-color: #757575;
    color: white;
  }

  .even-row {
    background-color: #757575;
    color: white;
  }

  .odd-row,
  .even-row {
    &:hover > td {
      background-color: ${YELLOW} !important;
      cursor: pointer;
      color: white;
    }
  }

  .content {
    padding: 50px;
    width: 100%;
    background-color: #1c2025;
    color: white;
  }
`;

export const NewTitrePage = () => {
  const history = useHistory();

  useEffect(() => {}, []);

  return (
    <Layout>
      <Container>
        {/** Obtain 'current' values in Sidebar component */}
        <div className='content'>
          <div style={{ marginTop: 20 }}>
            <div
              style={{
                borderRadius: '50%',
                padding: 5,
                backgroundColor: ORANGE,
                width: 40,
                height: 40,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
                marginBottom: 5,
              }}
              onClick={() => history.goBack()}
            >
              <FaArrowLeft size={20} />
            </div>

            <h2 style={{ marginBottom: 0, color: 'white' }}>
              Ajouter un nouveau titre
            </h2>
            <Divider
              style={{ marginTop: 1, borderWidth: 2, borderColor: 'white' }}
            />

            <BondForm />
          </div>
        </div>
      </Container>
    </Layout>
  );
};
